<!-- stepper.component.html -->
<div class="stepper-wrapper px-4 py-5 bg-white">
  <h2 class="text-2xl font-bold text-gray-900 mb-6">{{ 'STEPPER.APPLICATION_SECTIONS' | translate }}</h2>

  <div class="space-y-4">
    <ng-container *ngFor="let step of steps; let i = index; let last = last">
      <!-- Step Item -->
      <div class="relative">
        <!-- Step Card -->
        <div class="rounded-xl px-3 py-4 cursor-pointer" [ngClass]="{
            'bg-[#F0FDF4] border-teal-400 border-2': step.active || step.done,
            '': !step.active && !step.done,
            'hover:border-teal-300': step.active || step.done,
            'hover:border-gray-300': !step.active && !step.done
          }">
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-4">
              <div
                class="w-14 h-14 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300"
                [ngClass]="{
                  'bg-teal-500': step.active,
                  'bg-[#00C950]': step.done,
                  'bg-[#F3F3F5]': !step.active && !step.done
                }">
                <!-- Completed Step - Show Checkmark -->
                <ng-container *ngIf="step.done">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                    class="text-white">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="currentColor" />
                  </svg>
                </ng-container>

                <!-- Active or Inactive Step - Show Icon -->
                <ng-container *ngIf="!step.done">
                  <img [src]="
                      step.inactiveIcon && !step.active
                        ? step.inactiveIcon
                        : step.icon
                    " [alt]="step.label" class="w-7 h-7" [ngClass]="{
                      'opacity-100 brightness-0 invert': step.active
                    }" [ngStyle]="{
                      filter: step.active ? 'none' : 'invert(29%) '
                    }" />
                </ng-container>
              </div>

              <!-- Text Content -->
              <div class="flex-1">
                <h3 class="text-lg font-semibold mb-1 transition-colors" [ngClass]="{
                    'text-teal-900': step.active || step.done,
                    'text-gray-400': !step.active && !step.done
                  }">
                  {{ step.label | translate }}
                </h3>
                <p class="text-sm transition-colors" [ngClass]="{
                    'text-teal-700': step.active || step.done,
                    'text-gray-400': !step.active && !step.done
                  }">
                  {{ step.description | translate }}
                </p>
              </div>
            </div>

            <!-- Arrow Icon (only for active step) -->
            <div *ngIf="step.active" class="flex-shrink-0">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                class="text-teal-600">
                <path d="M9 18l6-6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Application Summary -->
  <div class="bg-white border border-gray-200 rounded-xl p-6 mt-6 shadow-sm">
    <h3 class="text-xl font-bold text-gray-900 mb-6">{{ 'STEPPER.APPLICATION_SUMMARY' | translate }}</h3>

    <div class="space-y-4">
      <div class="flex justify-between items-center">
        <span class="text-gray-600">{{ 'STEPPER.COMPANY' | translate }}:</span>
        <span class="font-semibold text-gray-900">{{
          selectedCompanyName
          }}</span>
      </div>

      <div class="flex justify-between items-center">
        <span class="text-gray-600">{{ 'STEPPER.EMPLOYEES' | translate }}:</span>
        <span class="font-semibold text-gray-900">{{ employeeCount }}</span>
      </div>

      <div class="flex justify-between items-center">
        <span class="text-gray-600">{{ 'STEPPER.MEMBERS_ADDED' | translate }}:</span>
        <span class="font-semibold text-gray-900">{{ totalMembers }}</span>
      </div>

      <div class="flex justify-between items-center">
        <span class="text-gray-600">{{ 'STEPPER.DEPENDENTS' | translate }}:</span>
        <span class="font-semibold text-gray-900">{{ dependentCount }}</span>
      </div>

      <div class="flex justify-between items-center">
        <span class="text-gray-600">{{ 'STEPPER.MALE' | translate }}:</span>
        <span class="font-semibold text-gray-900">{{ totalMale }}</span>
      </div>

      <div class="flex justify-between items-center">
        <span class="text-gray-600">{{ 'STEPPER.FEMALE' | translate }}:</span>
        <span class="font-semibold text-gray-900">{{ totalFemale }}</span>
      </div>


      <div class="flex justify-between items-center">
        <span class="text-gray-600">{{ 'STEPPER.SELECTED_QUOTE' | translate }}:</span>
        <span class="font-semibold text-gray-900">{{ selectedQuote }}</span>
      </div>

      <div class="border-t border-gray-200 pt-4 mt-4">
        <div class="flex justify-between items-center">
          <span class="text-gray-900 font-semibold">{{ 'STEPPER.PROGRESS' | translate }}:</span>
          <span class="text-teal-600 font-bold text-lg">{{ progress }}%</span>
        </div>
      </div>
    </div>
  </div>
</div>